<div class="mw-search-bar">
  <mat-form-field appearance="fill">
    <mat-label>
      {{ 'CORE.COMPONENT.SEARCH_BAR.search' | translate }}
    </mat-label>
    <input
      matInput
      [formControl]="searchControl"
      cdkFocusInitial
      placeholder="{{
        'CORE.COMPONENT.SEARCH_BAR.enter_search_string' | translate
      }}"
    />
    <mat-icon matSuffix (click)="onClear()" *ngIf="searchControl.value">
      close
    </mat-icon>
    <mat-icon matSuffix *ngIf="!searchControl.value">search</mat-icon>
  </mat-form-field>
</div>
